<template>
  <div>
    <div v-if="$store.state.step === 6" class="text-center">
      <h4>Complete!</h4>
      <h6 class="secondary">
        Your video has been successfully created and saved.
      </h6>
      <div style="80%" @click.prevent="next()">
        <img class="mt-4" :src="this.complete" width="100" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "StepSix",
  props: ["step"],
  mounted() {},
  data: function() {
    return {
      complete: "https://i.imgur.com/8L0l2ob.png",
    };
  },
  methods: {
    next() {
      this.$store.commit("changeStep", 7);
    },
  },
};
</script>
